<template>
  <div>
    <the-header ref="header"></the-header>
    <breadcrumb></breadcrumb>
    <div class="flex">
      <the-sidebar></the-sidebar>
      <div class="page-main-content flex-auto min-width-1000 m-4">
        <div class="mx-auto">
          <router-view :key="fullPath"></router-view>
        </div>
      </div>
    </div>
    <div v-show="isLoading">
      <loading v-model:active="isLoading" :is-full-page="isLoadingFullPage"></loading>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheHeader from '@/member/components/common/TheHeader'
import TheSidebar from '@/member/components/common/TheSidebar'
import Breadcrumb from '@/member/components/common/Breadcrumb'

export default {
  name: 'NormalLayout',
  components: { TheHeader, TheSidebar, Breadcrumb },
  computed: {
    ...mapGetters(['isCallingApi', 'isLoadingFullPage', 'loadingFlg']),
    fullPath() {
      return this.$route.fullPath
    },
    maxWidth() {
      const listRoute = ['center.berth.create', 'center.berth.schedule', 'transporter.work-schedule']
      if (listRoute.includes(this.$route.name)) {
        return false
      }
      return true
    },
    isLoading() {
      return this.isCallingApi && this.loadingFlg
    },
  },
}
</script>

<style scoped>

</style>
